// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__EQtlF","footer__logo":"footer_footer__logo__-IFpi"};